import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import MarketingLayout, { Seo, PageHero, FinalCta } from "@/components/marketing/MarketingLayout";
import { BLOG_POSTS } from "@/lib/marketingSite";
import { ArrowLeft } from "@phosphor-icons/react";

const fmtDate = (d) => new Date(d + "T12:00:00Z").toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = BLOG_POSTS.find((p) => p.slug === slug);
  if (!post) return <Navigate to="/blog" replace />;
  const related = BLOG_POSTS.filter((p) => p.slug !== slug).slice(0, 2);
  return (
    <MarketingLayout>
      <Seo title={`${post.title} | Vozelto Blog`} path={`/blog/${post.slug}`} description={post.description} />
      <PageHero caps={`${post.category} · ${fmtDate(post.date)} · ${post.read} read`} title={post.title} subtitle={post.description} />
      <article className="max-w-3xl mx-auto px-5 pb-16" data-testid="blog-article">
        {post.sections.map((s) => (
          <section key={s.h} className="mb-9">
            <h2 className="font-head font-bold text-2xl tracking-tight mb-3">{s.h}</h2>
            {s.p.map((para, k) => (
              <p key={k} className="text-[#b5b5b5] leading-relaxed mb-3">{para}</p>
            ))}
          </section>
        ))}
        <div className="mt-10 pt-8 border-t border-white/8">
          <Link to="/blog" data-testid="blog-back-link" className="inline-flex items-center gap-2 text-sm font-semibold brand-text hover:opacity-80">
            <ArrowLeft size={15} weight="bold" /> All articles
          </Link>
          <div className="mt-6 grid sm:grid-cols-2 gap-4">
            {related.map((r) => (
              <Link key={r.slug} to={`/blog/${r.slug}`} className="card-matte p-5 hover:border-[#6B3DFF]/30 border border-transparent transition-colors">
                <div className="text-[11px] brand-text font-semibold">{r.category}</div>
                <div className="mt-1.5 font-head font-semibold text-sm leading-snug">{r.title}</div>
              </Link>
            ))}
          </div>
        </div>
      </article>
      <FinalCta />
    </MarketingLayout>
  );
}
